
export enum TypingMode {
  TIME = 'time',
  WORDS = 'words',
  QUOTE = 'quote'
}

export enum Language {
  EN = 'english',
  RU = 'russian',
  KZ = 'kazakh'
}

export interface UserSettings {
  theme: string;
  fontSize: number;
  fontFamily: string;
  focusMode: boolean;
  language: Language;
}

export interface TypingStats {
  wpm: number;
  accuracy: number;
  rawWpm: number;
  errors: number;
  characters: {
    correct: number;
    incorrect: number;
    extra: number;
    missed: number;
  };
  consistency: number;
  time: number;
}

export interface HistoryEntry {
  second: number;
  wpm: number;
  raw: number;
  errors: number; // Количество ошибок, совершенных именно в эту секунду
}

export interface WordStatus {
  word: string;
  status: 'pending' | 'correct' | 'incorrect' | 'partially-correct';
  charStatuses: ('pending' | 'correct' | 'incorrect')[];
}

export interface SavedResult {
  id: string;
  uid?: string;
  userEmail?: string;
  timestamp: number;
  stats: TypingStats;
  history: HistoryEntry[];
  mode: TypingMode;
  language: Language;
  config: number;
}
